{
 "_meta": {
  "locale": "ro",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "Acum",
  "people": "Persoane",
  "cases": "Dosare",
  "agenda": "Agendă",
  "reviews": "Revizuiri",
  "prospects": "Prospectare",
  "insights": "Analize",
  "data": "Date și siguranță",
  "settings": "Setări",
  "lens": "Lupă"
 },
 "common": {
  "save": "Salvează",
  "cancel": "Anulează",
  "close": "Închide",
  "search": "Caută",
  "today": "Astăzi",
  "tomorrow": "Mâine",
  "new": "Nou",
  "edit": "Editează",
  "delete": "Șterge"
 },
 "settings": {
  "title": "Setări",
  "language": "Limbă",
  "region": "Piață / regiune",
  "theme": "Aspect"
 },
 "people": {
  "title": "Persoane",
  "new": "Persoană nouă"
 },
 "today": {
  "agenda_title": "Astăzi"
 },
 "lens": {
  "placeholder": "Caută persoane, prospecți, dosare — sau scrie o comandă"
 }
}